export const IOS = 'iOS'
export const ANDROID = 'Android'

function getUserAgent(): string {
  const userAgentString = navigator?.userAgent || ''
  return userAgentString.toLowerCase()
}

export function isIOS(): boolean {
  const ua = getUserAgent()

  return ua.includes('iphone') || ua.includes('ipad')
}

export function isAndroid(): boolean {
  const ua = getUserAgent()

  return ua.includes('android')
}

export default function isMobile(): boolean {
  if (isIOS() || isAndroid()) {
    return true
  }

  const ua = getUserAgent()
  return /Mobi/.test(ua)
}
